/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createAdviceTabStyles = makeStyles(() => ({
  infoPaper: { margin: '8px' },
  infoBoxLabel: {
    fontSize: '12px',
    color: '#909196',
  },
  infoBoxValue: {
    fontWeight: 700,
  },
}));

export { createAdviceTabStyles };
